export interface LocationWeatherSummary {
  temperature: number;
  weatherCode: number;
  isDay: boolean;
  fetchedAt: number;
  stale: boolean;
  lat: number;
  lng: number;
}
const weatherCodes = new Set([
  0, 1, 2, 3, 45, 48, 51, 53, 55, 56, 57, 61, 63, 65, 66, 67, 71, 73, 75, 77,
  80, 81, 82, 85, 86, 95, 96, 99,
]);
export function validSummaryCurrent(
  current:
    | { temperature?: number; weatherCode?: number; isDay?: number }
    | undefined,
): current is { temperature: number; weatherCode: number; isDay: number } {
  return (
    !!current &&
    Number.isFinite(current.temperature) &&
    ![-999, -999.99, Number.MIN_SAFE_INTEGER].includes(current.temperature!) &&
    weatherCodes.has(current.weatherCode!) &&
    (current.isDay === 0 || current.isDay === 1)
  );
}
/** Count whole shortcuts, reserving overflow only when all places cannot fit. */
export function fittingShortcutCount(
  widths: number[],
  available: number,
  moreWidth: number,
  gap = 8,
): number {
  const total =
    widths.reduce((sum, width) => sum + width, 0) +
    Math.max(0, widths.length - 1) * gap;
  if (total <= available) return widths.length;
  let used = moreWidth;
  let count = 0;
  for (const width of widths) {
    if (used + gap + width > available) break;
    used += gap + width;
    count++;
  }
  return count;
}
